import React from 'react';
import { cn } from '../../utils/cn';

export interface SpinnerProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  label?: string;
}

/** A small inline loading indicator. Respects prefers-reduced-motion. */
export const Spinner: React.FC<SpinnerProps> = ({ size = 20, label = 'Lädt', className, ...rest }) => (
  <svg
    className={cn('inline-block animate-spin motion-reduce:animate-none', className)}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    role="status"
    aria-label={label}
    {...rest}
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity="0.25" />
    <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);
